export enum ProductLocationAssortmentStatus {
    NoChange = 0,
    Added = 1,
    Removed = 2
}

(ProductLocationAssortmentStatus as any).__typeName = 'ProductLocationAssortmentStatus';
